exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".out-of-place-wizard .alert-box {\n  padding: 5px 0px 5px 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/out-of-place-restore.scss
// module id = f7Qk
// module chunks = 0